import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { theme, TimePickerFieldStyled } from "./time-picker-field.styles";
import { Controller } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import dayjs from "dayjs";

export const TimePickerField = ({
  label = "",
  value,
  onChange,
  error,
  ...props
}: any) => {
  const handleTimeChange = (time: any) => {
    if (!time) return;
    const formattedTime = dayjs(time).format("hh:mm A");
    onChange(formattedTime);
  };

  return (
    <ThemeProvider theme={theme}>
      <TimePickerFieldStyled>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box>
            {label && (
              <Typography
                className="label"
                variant="body2"
                sx={{ marginBottom: "4px" }}
              >
                {label}
              </Typography>
            )}
            <TimePicker
              value={value ? dayjs(value, "hh:mm A") : null} // Ensure correct format
              onChange={handleTimeChange}
              {...props}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                  error: Boolean(error),
                },
              }}
            />
            {error && (
              <Typography variant="caption" color="error">
                {error.message}
              </Typography>
            )}
          </Box>
        </LocalizationProvider>
      </TimePickerFieldStyled>
    </ThemeProvider>
  );
};

export const TimePickerFormField = (props: any) => {
  const { name, control, defaultValue, rules, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ""}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TimePickerField
          {...rest}
          value={value}
          error={error}
          onChange={onChange}
        />
      )}
    />
  );
};
